<template>
  <div>
    <alert ref="alert" />
    <router-view/>
  </div>
</template>

<script>
import Alert from "@/components/Alert";

export default {
  name: "App",
  components: {
    Alert
  },
  data() {
    return {};
  },
  mounted() {
    bus.$on("triggerAlert", options => {
      this.triggerAlert(options);
    });
  },
  methods: {
    triggerAlert(options) {
      this.$refs.alert.showAlert(options);
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/styles/common/_variables.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue